(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eden-bundle-home"] && !Shopify.designMode) return;
  try {
    
(()=>{const copy={nl:{eyebrow:'Uw eigen Eden-collectie',title:'Uw favoriete nummers, samen voor €45',text:'Kies 5 magazines voor België of 4 voor Nederland, Frankrijk en Luxemburg. Verzending inbegrepen naar deze landen. Eenmalig, zonder abonnement.',cta:'Kies uw magazines — €45'},fr:{eyebrow:'Votre collection Eden',title:'Vos numéros préférés, réunis pour 45 €',text:'Choisissez 5 magazines pour la Belgique ou 4 pour les Pays-Bas, la France et le Luxembourg. Livraison incluse dans ces pays. Achat unique, sans abonnement.',cta:'Choisir mes magazines — 45 €'}};const refresh=()=>document.querySelectorAll('[data-eden-home]').forEach(root=>{const lang=document.documentElement.lang.startsWith('fr')?'fr':'nl';root.lang=lang;root.querySelectorAll('[data-home-key]').forEach(el=>el.textContent=copy[lang][el.dataset.homeKey]);const link=root.querySelector('[data-home-link]');const url=new URL(link.href);url.searchParams.set('eden_lang',lang);link.href=url.href;});refresh();new MutationObserver(refresh).observe(document.documentElement,{attributes:true,attributeFilter:['lang']});document.addEventListener('shopify:section:load',refresh);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eden-mix-match"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const copy = JSON.parse(root.querySelector('[data-eden-copy]').textContent);
    let language = (document.documentElement.lang || root.dataset.locale).startsWith('fr') ? 'fr' : 'nl';
    const country = root.querySelector('[data-country-select]');
    const printLanguage = root.querySelector('[data-print-language]');
    const cards = [...root.querySelectorAll('[data-variant]')];
    const reviewed = root.querySelector('[data-reviewed]');
    const storageKey = 'eden-mix-selection-v2';
    const issueCopy=JSON.parse(root.querySelector('[data-issue-copy]').textContent);
    const packs = JSON.parse(root.querySelector('[data-eden-bundles]').textContent);
    let submitting = false;
    const europe = 'AT BG HR CY CZ DK EE FI GR HU IE IT LT MT NO PL PT RO SK SI ES SE GB AX AL AD AM BY BA FO GE GI GL GP GG VA IS IM JE XK LV LI MK YT MD ME RE SM RS SJ TR UA MC CH'.split(' ');
    const shipping = () => ['BE','NL','FR','LU'].includes(country.value) ? t('included') : country.value === 'DE' ? '€18' : europe.includes(country.value) ? '€28' : '€85,60';
    const limit = () => country.value === 'BE' ? 5 : country.value ? 4 : 0;
    const amount = card => Number(card.querySelector('input').value) || 0;
    const total = () => cards.reduce((sum,card) => sum + amount(card),0);
    const t = (key,values={}) => Object.entries(values).reduce((s,[k,v])=>s.replaceAll('{'+k+'}',v),copy[language][key]);
    const editionTitle = card => (printLanguage.value === 'fr' ? 'Numéro ' + (Number(card.dataset.number) - 2) : 'Nummer ' + Number(card.dataset.number));
    const selection = () => cards.filter(card=>amount(card)>0).map(card=>({variantId:card.dataset.variant,quantity:amount(card),title:editionTitle(card),handle:card.dataset.handle}));
    const save = () => {try{sessionStorage.setItem(storageKey,JSON.stringify({country:country.value,printLanguage:printLanguage.value,language,items:selection()}));}catch(e){}};
    function refresh() {
      const count = total(), required = limit();
      root.querySelectorAll('[data-i18n]').forEach(el=>{el.textContent=t(el.dataset.i18n);});
      root.setAttribute('lang',language);
      root.querySelectorAll('[data-language]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.language===language)));
      root.querySelector('[data-rule]').textContent=required?t('rule',{limit:required,shipping:shipping()}):t('unsupported');
      root.querySelector('[data-count]').textContent=t('count',{count,limit:required||'–'});
      root.querySelector('[data-mobile-count]').textContent=count+' / '+(required||'–');
      root.querySelector('[data-status]').textContent=!required?t('unsupported'):count>required?t('over',{extra:count-required}):count===required?t('complete'):t('remaining',{remaining:required-count});
      root.querySelector('progress').max=required||5;
      root.querySelector('progress').value=Math.min(count,required||5);
      const list=root.querySelector('[data-selection]');list.replaceChildren();
      for(const item of selection()){const li=document.createElement('li');li.textContent=item.quantity+' × '+item.title;list.append(li);}
      if(!count){const li=document.createElement('li');li.textContent=t('empty');list.append(li);}
      cards.forEach(card=>{
        const input=card.querySelector('input'),n=amount(card),stock=Number(card.dataset.stock);
        const title=editionTitle(card);
        card.querySelector('h2').textContent=title;
        card.querySelector('[data-highlights]').textContent=issueCopy[language][card.dataset.number]||'';
        card.querySelector('label').textContent=t('quantity')+' — '+title;
        const cover=card.querySelector('.eden-mix__cover img');
        if(cover)cover.alt=title;else card.querySelector('.eden-mix__cover span').textContent=title;
        input.max=String(Math.min(stock,Math.max(n,required-count+n)));
        input.disabled=!required||stock===0;
        card.dataset.selected=String(n>0);
        const minus=card.querySelector('[data-step="-1"]'),plus=card.querySelector('[data-step="1"]');
        minus.disabled=n===0;plus.disabled=!required||count>=required||n>=stock;
        minus.setAttribute('aria-label',t('remove')+' — '+editionTitle(card));
        plus.setAttribute('aria-label',t('add')+' — '+editionTitle(card));
      });
      root.querySelector('[data-review]').disabled=submitting||!required||count!==required||!printLanguage.value||!packs.length;
      root.querySelector('[data-reset]').disabled=count===0;
      reviewed.hidden=true;save();
    }
    printLanguage.value=language;
    country.value=[...country.options].some(o=>o.value===root.dataset.country)?root.dataset.country:'';
    try{
      const saved=JSON.parse(sessionStorage.getItem(storageKey)||'null');
      if(saved){
        if([...country.options].some(o=>o.value===saved.country))country.value=saved.country;
        
        if(saved.language===language&&['nl','fr'].includes(saved.printLanguage))printLanguage.value=saved.printLanguage;
        for(const item of saved.items||[]){const card=cards.find(c=>c.dataset.variant===item.variantId);if(card)card.querySelector('input').value=String(Math.max(0,Math.min(5,Number(card.dataset.stock),Math.floor(Number(item.quantity)||0))));}
      }
    }catch(e){}
    const requestedLanguage=new URLSearchParams(window.location.search).get('eden_lang');
    if(['fr','nl'].includes(requestedLanguage)){language=requestedLanguage;printLanguage.value=requestedLanguage;}
    root.addEventListener('click',async event=>{
      const button=event.target.closest('button');if(!button||button.disabled)return;
      if(button.dataset.language){const form=document.getElementById('EdenLanguages');if(form){form.querySelector('[value="'+button.dataset.language+'"]').click();return;}language=button.dataset.language;printLanguage.value=language;refresh();}
      if(button.dataset.step){const card=button.closest('[data-variant]'),input=card.querySelector('input');const next=amount(card)+Number(button.dataset.step);input.value=String(Math.max(0,Math.min(Number(card.dataset.stock),Number(button.dataset.step)>0?Math.max(0,limit()-(total()-amount(card))):amount(card),next)));refresh();}
      if(button.hasAttribute('data-recommend')){cards.forEach(c=>c.querySelector('input').value='0');let remaining=limit();for(const card of cards){if(remaining&&Number(card.dataset.stock)>0){card.querySelector('input').value='1';remaining--;}}refresh();}
      if(button.hasAttribute('data-reset')){cards.forEach(c=>c.querySelector('input').value='0');refresh();}
      if(button.hasAttribute('data-review')){
        if(submitting || total()!==limit() || !printLanguage.value)return;
        const pack=packs.find(p=>p.title.endsWith('— '+limit()));
        if(!pack){reviewed.textContent=t('cart_error');reviewed.hidden=false;return;}
        const components=typeof pack.items==='string'?JSON.parse(pack.items):pack.items;
        const chosen=selection(),tokens=[];
        for(const item of chosen){
          const component=components.find(c=>String(c.variant_id)===item.variantId);
          if(!component?.selection_token){reviewed.textContent=t('cart_error');reviewed.hidden=false;return;}
          for(let i=0;i<item.quantity;i++)tokens.push(component.selection_token);
        }
        if(tokens.length!==limit())return;
        submitting=true;refresh();reviewed.textContent=t('ready');reviewed.hidden=false;
        try{
          const response=await fetch(root.dataset.cartAdd,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:pack.id,quantity:1,properties:{_bundle_selection:tokens.join(' <> '),'Magazines':chosen.map(i=>i.quantity+' × '+i.title).join('; '),'Taal / Langue':printLanguage.value==='fr'?'Français':'Nederlands','Levering / Livraison':country.value}}]})});
          if(!response.ok){const detail=await response.json();throw new Error(typeof detail.description==='string'?detail.description:t('cart_error'));}
          window.location.assign(root.dataset.cartUrl);
        }catch(error){submitting=false;refresh();reviewed.textContent=error.message||t('cart_error');reviewed.hidden=false;reviewed.focus();}

      }
    });
    function handleChange(event) {
      if(event.target.matches('input[type="number"]')){
        const card=event.target.closest('[data-variant]'),previousOther=total()-amount(card);
        event.target.value=String(Math.max(0,Math.min(Number(card.dataset.stock),Math.max(0,limit()-previousOther),Math.floor(Number(event.target.value)||0))));
      }
      refresh();
      const term=root.querySelector('[data-issue-search]').value.trim().toLocaleLowerCase(),topic=root.querySelector('[data-topic]').value;
      cards.forEach(c=>{c.hidden=!(topic==='all'||c.dataset.topics.trim().split(/\s+/).includes(topic))||!(editionTitle(c)+' '+c.querySelector('[data-highlights]').textContent).toLocaleLowerCase().includes(term);});
      root.querySelector('[data-no-results]').hidden=cards.some(c=>!c.hidden);
    }
    root.addEventListener('input',handleChange);
    root.addEventListener('change',handleChange);
    refresh();
  }
  document.querySelectorAll('[data-eden-mix]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-eden-mix]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    document.addEventListener("change",function(event){if(event.target.id!=="EdenPrintLanguage")return;var n=Number(event.target.dataset.issue);document.getElementById("EdenIssueNumber").value=event.target.value==="Français"?"Numéro "+(n-2):"Nummer "+n;});
  } catch(e) { console.error(e); }
})();
})();
